import aT from '../const/action-type'
import initial from '../store/initial'
//
export default (state = initial.workspaceStats, action) => {
  switch (action.type) {
    case aT.SET_WORKSPACE_STATS:
      return action.data
    case aT.RESET_STORE:
      return initial.workspaceStats
    case aT.SWITCH_WORKSPACE:
      return initial.workspaceStats
    default:
      return state
  }
}
